/**
 * 패스트파이브(주) 회사 정보.
 */
const CUSTOMER_CENTER_NUMBER = '1833-5550';

export const COMPANY = {
  NAME: '패스트파이브(주)',
  CEO: '김대일, 신정우',
  BUSINESS_REGISTRATION_NUMBER: '151-81-00025',
  MAIL_ORDER_BUSINESS_NUMBER: '2019-서울서초-2113',

  CUSTOMER_CENTER_NUMBER,
  CUSTOMER_CENTER_TEL_HREF: `tel:${CUSTOMER_CENTER_NUMBER.replaceAll('-', '')}`,

  EMAIL: {
    GENERAL: 'contact@fastfive.co.kr',
    PR: 'pr@fastfive.co.kr',
    REAL_ESTATE: 'realestategroup@fastfive.co.kr',
  },

  ADDRESS: {
    LINE_1: '서울특별시 서초구 남부순환로333길 10,',
    LINE_2: '1층 102호 2층 3층(서초동, 원일빌딩)',
  },

  BUSINESS_HOURS: [
    { label: '월~금요일', value: '9:00 - 18:00' },
    { label: '점심시간', value: '12:00 - 13:00' },
  ],

  KAKAO_TALK_ID: '@FASTFIVE',
} as const;
